import { useQuery } from "react-query";
import ReferencingFormContent from "./ReferencingFormContent";
import { ReferencingFormProvider } from "./context/ReferencingFormContext";
import { Reception } from "$types";
import { ReceptionService } from "$services";
import { Loader } from "$components/Layout/Loader";
import { CacheInvalidationAction } from "$utils/cache";

type Props = {
  focusedReceptionReferenceId?: number;
  isReadOnly?: boolean;
  warehouse?: string;
  isSavingReception: boolean;
  onSubmit: (data: any) => Promise<any>;
  reception: Reception;
  togglePopin: (open: boolean) => void;
};

function ReferencingForm({ receptionId, ...rest }: any) {
  const res = useQuery({
    queryKey: [CacheInvalidationAction.GET_RECEPTION_BY_ID, receptionId],
    queryFn: () => ReceptionService.getReceptionById(receptionId),
    enabled: !!receptionId,
    staleTime: 60 * 1000,
  }) as any;

  const { data, isLoading } = res;

  if (isLoading) {
    return <Loader text="Chargement des produits..." />;
  }

  return <ReferencingFormInside reception={data} {...rest} />;
}

function ReferencingFormInside({
  focusedReceptionReferenceId,
  isReadOnly = false,
  warehouse,
  isSavingReception,
  onSubmit,
  reception,
  togglePopin,
}: Props) {
  return (
    <ReferencingFormProvider
      focusedReceptionReferenceId={focusedReceptionReferenceId}
      isReadOnly={isReadOnly}
      warehouse={warehouse}
      isSavingReception={isSavingReception}
      reception={reception}
      onSubmit={onSubmit}
      togglePopin={togglePopin}
    >
      <ReferencingFormContent />
    </ReferencingFormProvider>
  );
}

export default ReferencingForm;
